export default "__VITE_ASSET__BGrq9jdb__"